import { render } from "./CandidateProfileReferences.vue?vue&type=template&id=bd8bba16&scoped=true"
import script from "./CandidateProfileReferences.vue?vue&type=script&lang=js"
export * from "./CandidateProfileReferences.vue?vue&type=script&lang=js"

import "./CandidateProfileReferences.vue?vue&type=style&index=0&id=bd8bba16&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd8bba16"]])

export default __exports__